/*
load-angular-locale.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/widgets/angular-locale/load-angular-locale',['lodash'], function (_) {
    'use strict';

    require.config({
        paths: {
            'angular-locale_en': 'modules/shell/3rdparty/angular-i18n/angular-locale_en',
            'angular-locale_fr': 'modules/shell/3rdparty/angular-i18n/angular-locale_fr',
            'angular-locale_de': 'modules/shell/3rdparty/angular-i18n/angular-locale_de',
            'angular-locale_ja': 'modules/shell/3rdparty/angular-i18n/angular-locale_ja',
            'angular-locale_it': 'modules/shell/3rdparty/angular-i18n/angular-locale_it',
            'angular-locale_es': 'modules/shell/3rdparty/angular-i18n/angular-locale_es',
            'angular-locale_he': 'modules/shell/3rdparty/angular-i18n/angular-locale_he'
        },

        shim: {
            'angular-locale_en': { deps: ['angular'] },
            'angular-locale_fr': { deps: ['angular'] },
            'angular-locale_de': { deps: ['angular'] },
            'angular-locale_ja': { deps: ['angular'] },
            'angular-locale_it': { deps: ['angular'] },
            'angular-locale_es': { deps: ['angular'] },
            'angular-locale_he': { deps: ['angular'] }
        }
    });

    var supportedLocaleCodes = ['en', 'fr', 'de', 'es', 'it', 'ja', 'he'],
        acceptedLang = (window.ACCEPTED_LANGUAGE) ? window.ACCEPTED_LANGUAGE.split(',')[0] : '',

        //get current language code
        localeCode = (acceptedLang || (navigator.languages && navigator.languages[0]) || navigator.language || navigator.browserLanguage || navigator.systemLanguage || navigator.userLanguage).split('-')[0];

    //check presence in supported list
    localeCode = _.find(supportedLocaleCodes, function (code) { return code === localeCode; });

    // Load the appropriate angular locale file
    if (localeCode) {
        require(['angular-locale_' + localeCode]);
    }
});
